import {
	withSelect,
	withDispatch,
	select,
	dispatch,
} from '@wordpress/data';
window.document.addEventListener(
	'DOMContentLoaded',
	function() {
		const isEditorReadyPromise = new Promise( ( resolve ) => {
			console.log( wp.data.select( 'core/editor' ).getEditedPostAttribute( 'meta' ) );
			//approximate editor ready by checking for clean post/blocks loaded
			const unsubscribe = wp.data.subscribe( () => {
				console.log( wp.data.select( 'core/editor' ) );
				const isNewPost = wp.data.select( 'core/editor' ).isCleanNewPost();
				if ( isNewPost ) {
					unsubscribe();
					resolve();
				}
				const blocks = wp.data.select( 'core/editor' ).getBlocks();
				if ( blocks.length > 0 ) {
					unsubscribe();
					resolve();
				}
				console.log( wp.data.select( 'core/editor' ) );
			} );
		} );

		isEditorReadyPromise.then( () => {
			//do your work here.
			console.log( 'editor ready' );
			console.log( wp.data.select( 'core/editor' ).getEditedPostAttribute( 'meta' ) );
		} );
	}
);

// import KadenceElements from './elements-settings';
// wp.domReady( () => {
// 	ReactDOM.render(
// 		<KadenceElements />,
// 		document.querySelector( '.kadence_elements_classic_meta' )
// 	);
// } );